import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Checkbox from '@material-ui/core/Checkbox';
import Icon, { IconButton } from '@projeccions-pdc/react-icon';
import Tag from './Tag';
import Dropzone from 'react-dropzone';
import SimpleEditor from './SimpleEditor';
import Helpers, { getFileURL } from './helpers';
import YesNoModal from './YesNoModal';
import { withStyles } from '@material-ui/core/styles';
import LocalizedStrings from './localization.js';
import Button from '@material-ui/core/Button';
import TaggerModal from './TaggerModal';
import NewNotificationModal from '../Notifications/NewNotificationModal';
import GroupSelector from '../Common/GroupSelector/GroupSelector';
import BoundTo from './BoundTo';
import UpdateFileController from './UpdateFileController';
import { cloneDeep } from 'lodash';

let styles = {
    singleDropzone: {
        backgroundColor: '#dfdfdf',
        width: '290px',
        border: '0px',
        marginTop: '10px',
        marginBottom: '10px',
        borderRadius: '5px',
        padding: '10px',
    },
    singleDropzoneContainer: {
        position: 'relative',
        height: '100px',
        borderWidth: '2px',
        borderColor: '#fff',
        borderStyle: 'dashed',
        borderRadius: '5px',
        paddingBottom: '30px',
    },
    dropzoneBrowse: {
        backgroundColor: '#fff',
        position: 'absolute',
        bottom: '15px',
        right: '15px',
        borderRadius: '5px',
        cursor: 'pointer',
    },
};

class FileDetailDrawer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            uploadedFile: {},
            fileProgress: 0,
            uploadErrorHidden: true,
            showModal: false,
            fileUploadError: '',
            visible: false,
            imageLoading: false,
            showTaggerModal: false,
            newNotificationModalOpen: false,
        };
        //BINDINGS
        this.closeDrawer = this.closeDrawer.bind(this);
        this.handleBrowseClick = this.handleBrowseClick.bind(this);
        this.onDropFiles = this.onDropFiles.bind(this);
        this.fileProgressCallback = this.fileProgressCallback.bind(this);
        this.handleDeleteFile = this.handleDeleteFile.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.handleCloseModal = this.handleCloseModal.bind(this);
        //this.imageLoaded = this.imageLoaded.bind(this);

        this._updateFileController = new UpdateFileController();
    }

    static getDerivedStateFromProps(props, state) {
        if (props.currentFile) {
            let loadingImage = false;
            if (state.oldCurrentFile) {
                loadingImage = state.oldCurrentFile.url !== props.currentFile.url;
            }
            return {
                visible: true,
                imageLoading: loadingImage,
                oldCurrentFile: props.currentFile,
            };
        } else {
            return { visible: false };
        }
    }

    // imageLoaded() {
    //     this.setState({ imageLoading: false });
    // }

    closeDrawer(evt) {
        if (this.props.closeDrawer) {
            this.props.closeDrawer(false);
            this.setState({ visible: false });
        }
    }

    handleBrowseClick() {
        this.refs.dropzone.open();
    }

    onDropFiles = async (newFiles) => {
        const newFile = newFiles[0];
        let currentFile = this.props.currentFile;
        this.setState({ uploadErrorHidden: true, uploadedFile: newFile });
        let response = await this._updateFileController.updateFile(currentFile, newFile, this.fileProgressCallback);

        if (response === 'uploadFileError') {
            this.setState({
                fileProgress: 0,
                uploadErrorHidden: false,
                uploadedFile: {},
                fileUploadError: LocalizedStrings.uploadFileError,
            });
        } else if (response === 'sameFileTypeError') {
            this.setState({ uploadErrorHidden: false, fileUploadError: LocalizedStrings.sameFileTypeError });
        } else {
            // console.log('setCurrentFile', { ...currentFile, ...response })
            this.props.setCurrentFile({ ...currentFile, ...response });
            this.setState({
                fileProgress: 0,
                uploadErrorHidden: true,
                uploadedFile: {},
                newNotificationModalOpen: true,
                imageHash: new Date().getTime(),
            });
        }
    };

    // onDropFiles(newFiles) {
    //     const newFile = newFiles[0];
    //     if (newFile.name.split('.').pop() === this.props.currentFile.filename.split('.').pop()) {
    //         this.setState({ uploadErrorHidden: true, uploadedFile: newFile });
    //         let fileId = this.props.currentFile.fileId;
    //         FileService.replaceFile(
    //             fileId,
    //             newFile,
    //             newFile.name,
    //             newFile.type,
    //             undefined,
    //             this.fileProgressCallback
    //         ).then((cbData) => {
    //             this._updateFileController.onFileUpdated(cbData, fileId);
    //             this.setState({ fileProgress: 0, uploadErrorHidden: true, uploadedFile: {}, newNotificationModalOpen: true });
    //         }).catch((err) => {
    //             console.log('err');
    //             console.log(err);
    //             this.setState({ fileProgress: 0, uploadErrorHidden: false, uploadedFile: {}, fileUploadError: LocalizedStrings.uploadFileError });
    //         });
    //     } else {
    //         this.setState({ uploadErrorHidden: false, fileUploadError: LocalizedStrings.sameFileTypeError });
    //     }
    // }

    fileProgressCallback(p) {
        this.setState({ fileProgress: p.progress });
    }

    handleDeleteFile() {
        this.setState({ showModal: true });
    }

    handleCloseModal() {
        this.setState({ showModal: false });
    }

    onBlur() {
        this.setState({ visible: false });
    }

    askForTag = () => {
        this.setState({ showTaggerModal: true });
    };

    handleCloseTaggerModal = () => {
        this.setState({ showTaggerModal: false });
    };

    handleCloseNewNotificationModal = () => {
        this.setState({ newNotificationModalOpen: false });
    };

    handleFilenameChange = async (newFilename) => {
        let currentFile = this.props.currentFile;
        if (currentFile.filename !== newFilename) {
            const oldFilename = currentFile.filename;
            currentFile.filename = newFilename;
            this.props.setCurrentFile(currentFile);

            let newElement = await this._updateFileController.onFilenameChanged(currentFile, newFilename, oldFilename);
            this.props.setCurrentFile(newElement);
        }
    };

    onChangeShareable = async (evt) => {
        let currentFile = this.props.currentFile;
        let checked = evt.target.checked;
        if (currentFile.shareable !== checked) {
            const oldShareable = currentFile.shareable;
            currentFile.shareable = checked;
            this.props.setCurrentFile(currentFile);

            let newElement = await this._updateFileController.onChangeShareable(currentFile, checked, oldShareable);
            this.props.setCurrentFile(newElement);
        }
    };

    handleDeleteTag = async (tag) => {
        let currentFile = cloneDeep(this.props.currentFile);
        let oldTags = cloneDeep(currentFile.tags);

        if (Array.isArray(currentFile.tags)) {
            currentFile.tags = currentFile.tags.filter((t) => t !== tag);
        } else {
            currentFile.tags.values = currentFile.tags.values.filter((t) => t !== tag);
        }
        this.props.setCurrentFile(currentFile);

        let newElement = await this._updateFileController.handleDeleteTag(currentFile, tag, oldTags);
        this.props.setCurrentFile(newElement);
    };

    handleAddTags = async (tags) => {
        let currentFile = this.props.currentFile;
        let response = this._updateFileController.handleAddTags(currentFile, tags);
        let tempState = response.tempState;
        let promise = response.promise;
        this.props.setCurrentFile(tempState);
        let newElement = await promise;
        this.props.setCurrentFile(newElement);
    };

    handleGroupSelected = (groupId, group) => {
        if (groupId) {
            this._updateFileController.changeGroup(this.props.currentFile, groupId).then((newElement) => {
                this.props.setCurrentFile(newElement);
                console.log(newElement);
            });
        }
    };

    handleGroupRemove = () => {
        this._updateFileController.removeGroup(this.props.currentFile).then((newElement) => {
            this.props.setCurrentFile(newElement);
        });
    };

    deleteFile = async () => {
        let currentFile = this.props.currentFile;
        let response = await this._updateFileController.deleteFile(currentFile);

        if (response.indexOf('Error') === -1) {
            this.props.removeDeletedFile(currentFile.fileId);
        } else {
            this.props.notify('error', response);
        }
    };

    render() {
        let tagsComponents = '';
        let boundToComponents;
        if (this.props.currentFile) {
            let currentTags = [];
            if (this.props.currentFile.tags) {
                if (Array.isArray(this.props.currentFile.tags)) {
                    currentTags = this.props.currentFile.tags;
                } else {
                    currentTags = this.props.currentFile.tags.values;
                }
            }

            tagsComponents = currentTags.map((tag) => <Tag key={tag} tag={tag} handleDeleteTag={this.handleDeleteTag} />);
            boundToComponents = this.props.currentFile.boundTo
                ? this.props.currentFile.boundTo.map((resource) => (
                      <BoundTo
                          key={resource.resourceId}
                          {...resource}
                          resourceType={'content'}
                          openContent={this.props.openContent}
                          openFileViewer={this.props.openFileViewer}
                      />
                  ))
                : '';
        }
        const uploadProgressBar = (
            <div>
                <div
                    style={{
                        backgroundColor: 'rgba(0,0,0,.1)',
                        width: 'calc(100% - 10px)',
                        borderRadius: '5px',
                        marginLeft: '5px',
                        marginRight: '5px',
                    }}
                >
                    <div
                        style={{
                            textAlign: 'center',
                            backgroundColor: '#62BE65',
                            opacity: '0.6',
                            width: this.state.fileProgress + '%',
                            color: '#fff',
                            borderRadius: '5px',
                        }}
                    >
                        {this.state.fileProgress + '%'}
                    </div>
                </div>
            </div>
        );

        let previewElement = '';
        if (this.props.currentFile && this.props.currentFile.fileType) {
            if (this.props.currentFile.fileType === 'video') {
                previewElement = <Icon name="md-play-circle-outline" size="100px" />;
            } else if (this.props.currentFile.fileType === 'image') {
                let url = getFileURL(this.props.currentFile.fileId);
                if (url.indexOf('?') !== -1) {
                    url = `${url}&${this.state.imageHash}`;
                } else {
                    url = `${url}?${this.state.imageHash}`;
                }
                previewElement = (
                    <img
                        style={{ width: '100%', height: '100px', objectFit: 'contain', verticalAlign: 'top', objectPosition: '0 0' }}
                        //src={getFileURL(this.props.currentFile.fileId)}
                        src={url}
                        alt={this.props.currentFile.fileId}
                    />
                );
            } else if (this.props.currentFile.fileType === 'file') {
                previewElement = <Icon name="fa-file-text-o" size="100px" />;
            }
        }

        return (
            <div
                data-id="library-file-detail"
                style={this.props.isDrawer === true ? { padding: '20px', width: '310px' } : { padding: '0px 20px', width: '620px' }}
            >
                {this.props.closeDrawer && (
                    <IconButton
                        name="md-arrow-forward"
                        size="25px"
                        onClick={this.closeDrawer}
                        primaryColor="#000"
                        secondaryColor="#9b9b9b"
                    />
                )}
                <div style={{ marginTop: this.props.isDrawer === true ? '20px' : '0px' }}>
                    <div
                        style={
                            this.props.isDrawer !== true && this.props.isSmartphone !== true
                                ? { display: 'inline-block', width: '50%', verticalAlign: 'top' }
                                : {}
                        }
                    >
                        <div>
                            <div
                                style={{
                                    width: '100%',
                                    height: '100px',
                                    objectFit: 'contain',
                                    verticalAlign: 'top',
                                    objectPosition: '0 0',
                                    textAlign: 'left',
                                }}
                            >
                                {previewElement}
                            </div>
                            <div style={{ lineHeight: '25px', marginTop: '20px' }}>
                                <SimpleEditor
                                    initialValue={
                                        this.props.currentFile && this.props.currentFile.filename ? this.props.currentFile.filename : ''
                                    }
                                    onChangeValue={this.handleFilenameChange}
                                />
                                {this.props.currentFile ? Helpers.humanFileSize(this.props.currentFile.fileSize) : ''}
                                <br />
                                {this.props.currentFile && this.props.usersData[this.props.currentFile.userSub]
                                    ? this.props.usersData[this.props.currentFile.userSub].name
                                    : ''}
                                <br />
                                {this.props.currentFile
                                    ? new Date(
                                          this.props.currentFile.lastUpdated
                                              ? this.props.currentFile.lastUpdated
                                              : this.props.currentFile.dateCreated
                                      ).toLocaleString()
                                    : ''}
                            </div>
                        </div>
                        <br />
                        {LocalizedStrings.shareable}
                        <Checkbox
                            checked={this.props.currentFile ? this.props.currentFile.shareable : false}
                            onChange={this.onChangeShareable}
                            color="primary"
                        />
                        <br />
                        <div>
                            {'User Group: '}
                            <GroupSelector
                                disabled={false}
                                onGroupSelected={this.handleGroupSelected}
                                selectedGroup={this.props.currentFile ? this.props.currentFile.groupId : undefined}
                                removeGroup={this.handleGroupRemove}
                            />
                        </div>
                        <br />
                    </div>
                    <div
                        style={
                            this.props.isDrawer !== true && this.props.isSmartphone !== true
                                ? { display: 'inline-block', width: '50%', verticalAlign: 'top' }
                                : {}
                        }
                    >
                        <div>
                            {/* <IconButton name="fa-tags" onClick={this.askForTag} /> */}
                            {LocalizedStrings.tags}
                            {'  '}
                            {/* <IconButton name='md-add' onClick={this.askForTag} /> */}
                            <div className="pdc-lb-addtag" onClick={this.askForTag}>
                                <Icon name="fa-tags" />
                                <Icon name="fa-plus" size="0.4rem" />
                            </div>
                            <br />
                            <TaggerModal
                                open={this.state.showTaggerModal}
                                handleClose={this.handleCloseTaggerModal}
                                handleYes={this.handleAddTags}
                            />
                            <div style={{ maxWidth: '300px' }}>{tagsComponents}</div>
                        </div>
                        <br />
                        <div>
                            {'Used in:'}
                            <br />
                            {boundToComponents}
                        </div>
                        <br />
                        <div>
                            {LocalizedStrings.updateFile}
                            <div>
                                <Dropzone
                                    ref="dropzone"
                                    className={this.props.classes.singleDropzone}
                                    multiple={false}
                                    disableClick={true}
                                    onDrop={this.onDropFiles}
                                >
                                    <div className={this.props.classes.singleDropzoneContainer}>
                                        <span>{this.state.uploadedFile.name}</span>
                                        <div className={this.props.classes.dropzoneBrowse}>
                                            <Button variant="outlined" onClick={this.handleBrowseClick}>
                                                {LocalizedStrings.browseFiles}
                                            </Button>
                                        </div>
                                    </div>
                                </Dropzone>
                                {this.state.uploadErrorHidden ? (
                                    ''
                                ) : (
                                    <div style={{ backgroundColor: '#f00' }}>{this.state.fileUploadError}</div>
                                )}
                            </div>
                            {this.state.fileProgress > 0 ? uploadProgressBar : ''}
                        </div>
                        <Button variant="outlined" onClick={this.handleDeleteFile}>
                            {LocalizedStrings.delete}
                        </Button>
                    </div>
                </div>
                <YesNoModal
                    size={'small'}
                    open={this.state.showModal}
                    handleClose={this.handleCloseModal}
                    handleYes={this.deleteFile}
                    title={LocalizedStrings.deleteFile}
                    message={LocalizedStrings.deleteFileMessage}
                    positive={LocalizedStrings.yes}
                    negative={LocalizedStrings.no}
                />
                <NewNotificationModal
                    resource={this.props.currentFile}
                    open={this.state.newNotificationModalOpen}
                    onClose={this.handleCloseNewNotificationModal}
                    notify={this.props.notify}
                    corporateColors={this.props.corporateColors}
                />
            </div>
        );
    }
}

FileDetailDrawer.propTypes = {
    isDrawer: PropTypes.bool.isRequired,
    currentFile: PropTypes.object,
    usersData: PropTypes.object.isRequired,
    // onFileUpdated: PropTypes.func.isRequired,
    // handleDeleteTag: PropTypes.func.isRequired,
    setCurrentFile: PropTypes.func.isRequired,
    // onChangeShareable: PropTypes.func.isRequired,
    // handleAddTags: PropTypes.func.isRequired,
    removeDeletedFile: PropTypes.func.isRequired,
    closeDrawer: PropTypes.func,
    classes: PropTypes.object.isRequired,
    notify: PropTypes.func.isRequired,
    openContent: PropTypes.func.isRequired,
    openFileViewer: PropTypes.func.isRequired,
    isSmartphone: PropTypes.bool,
};

export default withStyles(styles)(FileDetailDrawer);
